import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import 'react-phone-input-2/lib/style.css';

export const ContactUsWrapper = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn};
  margin-top: 50px;
  position: relative;
  padding: 100px 20px;
`;

export const StyledImageContainer = styled.div`
  width:100%;
  height:100%;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
`;

export const FullContactContainer = styled.div`
  width: 1408px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(255, 255, 255, 0.33);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 50px;

  @media only screen and ${deviceMax.desktop} {
    width: 1081px;
  }

  @media only screen and ${deviceMax.laptopLMax} {
    width: 608px;
  }

  @media only screen and ${deviceMax.tablet} {
    width: 100%;
    padding: 20px;
  }
`;

export const GetInTouch = styled.div`
  ${FONT_FAMILY.FontBold}
  ${FONTS.font24}
  color: ${COLORS.mainColor};
  width: 191px;
  text-transform: capitalize;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FONTS.font16}
  }
`;

export const AboutUsBlock = styled.div`
  ${FONT_FAMILY.FontRegular}
  width: 665px;

  ${FONTS.font16}
  color: ${COLORS.black};

  @media only screen and ${deviceMax.laptopLMax} {
    ${FONTS.font14}
    width: 100%;
  }

  @media only screen and ${deviceMax.mobileL} {
    ${FONTS.font12}
  }
`;

export const FormContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  align-items: flex-start;
  gap: 50px;
  margin-top: 30px;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow}
    flex-wrap: wrap;
    margin-top: 20px;
  }
`;
